var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeIndicatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 19.2,
    viewBox: "0 0 19.2 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type_indicator",
    "data-name": "Type indicator",
    transform: "translate(-47.399 -47.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M49.707,62.365a.978.978,0,0,0-.17-.643,1.843,1.843,0,0,0-.11-.164A8.646,8.646,0,0,1,48,56.8,9.02,9.02,0,0,1,65.807,55,8.609,8.609,0,0,1,66,56.8a8.823,8.823,0,0,1-8.852,8.867A10.593,10.593,0,0,1,54.7,65.31c-.583-.163-1.165-.379-1.315-.437a1.347,1.347,0,0,0-.482-.09,1.328,1.328,0,0,0-.523.105l-2.935,1.059a.689.689,0,0,1-.2.053.416.416,0,0,1-.415-.421.686.686,0,0,1,.026-.142Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#7e8185",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(51.347 55.65)",
    fill: "#1738f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Z",
    transform: "translate(55.649 55.65)",
    fill: "#4f85fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(59.951 55.65)",
    fill: "#c9d8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeIndicatorIcon);
export default __webpack_public_path__ + "static/media/type-indicator-icon.07a95d099f87921005a4d2e30fde738a.svg";
export { ForwardRef as ReactComponent };